import { logWrapper } from '../../utils';

export default {
  cancelPasswordModalController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'authService',
    '$timeout',
    '$location',
    '$window',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      authService,
      $timeout,
      $location,
      $window
    ) {
      'use strict';

      function parent_cancelButton() {
        $rootScope.cancelChangePasswordModal.close();
      }

      function questionModal() {
        $rootScope.cancelChangePasswordModal.close();
        $rootScope.showChangePassModal.close();
        if ($scope.isChangeOnLogin) {
          authService.logOut();
          $timeout(function () {
            $window.location.reload();
            $location.path('/login');
          }, 0);
        }
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
